module.exports = __webpack_public_path__ + "static/media/edit.7aa18b49.svg";